// extracted by mini-css-extract-plugin
export default {"styles":"UploadImage_styles__d98Ga"};